<template>
  <v-card width="300px" light>
    <v-card-title class="subtitle-2">
      Download Excel Sheet
      <v-spacer></v-spacer>
      <v-btn fab text small @click="close">
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <p class="subtitle-1">Select Format :</p>
      <v-radio-group v-model="selectedFormat">
        <v-radio label="MEDA" value="meda" color="primary"></v-radio>
        <v-radio
          label="MEDA (MSEDCL)"
          value="meda-msedcl"
          color="primary"
        ></v-radio>
      </v-radio-group>
      <v-menu
        v-model="fromDateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="fromDateFormatted"
            label="From"
            prepend-icon="mdi-calendar"
            v-on="on"
            readonly
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="from"
          no-title
          @input="fromDateMenu = false"
          color="primary"
        ></v-date-picker>
      </v-menu>
      <v-menu
        v-model="toDateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="toDateFormatted"
            label="To"
            prepend-icon="mdi-calendar"
            v-on="on"
            readonly
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="to"
          no-title
          @input="toDateMenu = false"
          color="primary"
        ></v-date-picker>
      </v-menu>
      <div v-if="downloadFailed">
        <p class="error--text">
          {{ errorMessage }}
        </p>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="primary" @click="downloadFile" :loading="downloadingFile">
        <v-icon left> mdi-download</v-icon>
        Download File
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { nodeRestApi } from '../plugins/api';
import { dateOnlyFormat, getFromDate } from '../plugins/date';
import { convert } from '../plugins/convertBase64ToFile';
export default {
  name: 'download-xlsx',
  props: {
    deviceType: {
      type: String,
      required: true
    },
    deviceId: {
      type: String,
      required: true
    },
    minDate: {
      type: String,
      required: true
    },
    maxDate: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedFormat: 'meda',
      fromDateMenu: false,
      toDateMenu: false,
      from: getFromDate(this.maxDate),
      to: this.maxDate,
      downloadingFile: false,
      errorMessage: '',
      downloadFailed: false
    };
  },
  computed: {
    fromDateFormatted() {
      return dateOnlyFormat(this.from);
    },
    toDateFormatted() {
      return dateOnlyFormat(this.to);
    }
  },
  methods: {
    close() {
      this.$emit('closeDownload');
    },
    async downloadFile() {
      this.downloadingFile = true;
      this.downloadFailed = false;
      try {
        const response = await nodeRestApi({
          method: 'POST',
          url: `${this.deviceType}/xlsx/${this.deviceId}`,
          data: {
            from: this.from,
            to: this.to,
            format: this.selectedFormat
          },
          timeout: 600000
        });

        const fileLink = document.createElement('a');
        if (response.data.url) {
          fileLink.href = response.data.url;
          fileLink.setAttribute('target', '_self');
        } else if (response.data.file) {
          const fileURL = window.URL.createObjectURL(
            new Blob([convert().base64ToArrayBuffer(response.data.file)])
          );
          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `Ecotron RMS Report - ${response.data.portalName} - ${this.from} to ${this.to} - ${this.deviceId}.xlsx`
          );
        } else {
          throw new Error('Invalid response from server');
        }

        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
      } catch (error) {
        this.downloadFailed = true;
        if (error.isAxiosError) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            this.errorMessage = error.response.data.error.message;
          } else if (error.response && error.response.data) {
            this.errorMessage = JSON.stringify(error.response.data);
          } else {
            this.errorMessage = error.message;
          }
        } else {
          this.errorMessage = error.message || String(error);
        }
      } finally {
        this.downloadingFile = false;
      }
    }
  }
};
</script>

<style></style>
